import { useQuery } from 'react-query';
import { axios, axios2 } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { ApiResponse, Listing } from '@/types';

export const getBusinessDetail = (
  id: string,
  customer_id?: string
): Promise<ApiResponse<Listing>> => {
  const searchParams = new URLSearchParams(document.location.search);
  const PageType = searchParams.get('type');
  return axios2.get(
    `panel-api/common-properties-detail?id=${id}&type=${PageType}&customer_id=${customer_id ?? ''}`
  );
};

type QueryFnType = typeof getBusinessDetail;

type UseBusinessOptions = {
  config?: QueryConfig<QueryFnType>;
  id: string;
  customer_id: any;
};

export const useBusinessDetails = (
  { config, id, customer_id }: UseBusinessOptions = { id: '1', customer_id: '' }
) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['get-business-detail'],
    queryFn: () => getBusinessDetail(id, customer_id ?? ''),
  });
};
